import useRTL from "@/hooks/useRTL";
import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react";
import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();
  const isRTL = useRTL();
  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      dir={isRTL ? "rtl" : "ltr"}
      position={isRTL ? "bottom-left" : "bottom-right"}
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      toastOptions={{
        classNames: {
          toast: "!bg-background !text-foreground !border-border",
          success: "!text-green-600 dark:!text-green-400 !border !border-green-500",
          error: "!text-red-600 dark:!text-red-400 !border !border-red-500",
          warning: "!text-yellow-600 dark:!text-yellow-400 !border !border-yellow-500",
          info: "!text-blue-600 dark:!text-blue-400 !border !border-blue-500",
        },
      }}
      style={
        {
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
